import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "/public/css/goods.css";
import { computed, ref, onMounted, onBeforeMount, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from "vue-router";
import httpRequest from '@/request/index';
import { showToast, showFailToast, showLoadingToast, closeToast } from 'vant';
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const goodsList = ref([]);
    const addList = ref([]);
    const addressID = ref(0);
    const totalPrice = ref(0);
    const submitBarText = ref("提交订单");
    const isShow = ref(false);
    const onSubmit = () => {
      if (addressID.value == 0) {
        showFailToast("收货地址不能为空");
      }
      showLoadingToast({
        message: '提交中',
        forbidClick: true
      });
      let flist = [];
      let formData = {
        addid: addressID.value,
        goods: {}
      };
      for (let key in goodsList.value) {
        flist.push({
          id: key,
          count: cartList.value[key].count
        });
      }
      formData.goods = JSON.stringify(flist);
      httpRequest({
        method: "post",
        url: "?file=order&act=save",
        data: formData
      }).then(res => {
        closeToast();
        console.log(res);
        if (res.state == 1) {
          //删除购物车
          for (let key in goodsList.value) {
            store.dispatch("editCart", {
              id: key,
              count: 0
            });
          }
          showToast({
            message: "提交成功",
            onClose: function () {
              router.push("/order");
            }
          });
        } else {
          showFailToast(res.msg);
        }
      });
      console.log("提交订单");
    };
    const goBack = () => {
      router.go(-1);
    };
    let cartList = computed(() => {
      return store.state.cartItem;
    });
    onBeforeMount(() => {
      document.getElementsByTagName("body")[0].className = "bg_body";
      httpRequest({
        method: "get",
        url: "?file=address"
      }).then(res => {
        if (res.state == 1) {
          addList.value = res.list;
          addressID.value = res.default;
        } else {
          showFailToast(res.msg);
        }
      });
    });
    onBeforeUnmount(() => {
      document.body.removeAttribute("class", "bg_body");
    });
    onMounted(async () => {
      await store.dispatch("cklogin").then(() => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
      totalPrice.value = 0;
      let goodsId = "0";
      let buyGoods = JSON.parse(localStorage.getItem("buyGoods")) || [];
      buyGoods.forEach(function (key) {
        goodsId += "," + key;
      });
      await httpRequest({
        method: "get",
        url: "?file=goods&act=list&id=" + goodsId
      }).then(res => {
        closeToast();
        if (res.state == 1) {
          goodsList.value = res.list;
          isShow.value = true;
          console.log(goodsList.value);
        } else {
          showFailToast(res.msg);
        }
      });
      buyGoods.forEach(function (key) {
        totalPrice.value += goodsList.value[key].price * cartList.value[key].count * 100;
      });
      submitBarText.value = "提交订单(" + buyGoods.length + ")";
      //console.log(cartList.value);
    });
    return {
      cartList,
      totalPrice,
      goodsList,
      addressID,
      addList,
      onSubmit,
      goBack,
      isShow,
      submitBarText
    };
  }
};